export const MODULES = [
  { key: "materials", label: "Materiale", path: "/materiale" },
  { key: "calculator", label: "Calculator", path: "/calculator" },
  { key: "deviz", label: "Deviz materiale", path: "/deviz" },
  { key: "invoices", label: "Facturi", path: "/facturi" },
  { key: "vehicles", label: "Vehicule", path: "/vehicule" },
  { key: "notes", label: "Notite", path: "/notite" },
];

export const EMPTY_PERMS = {
  materials: false,
  calculator: true,
  deviz: true,
  invoices: "own",
  vehicles: false,
  notes: false,
};

export function can(user, key) {
  const v = user?.permissions?.[key];
  return Boolean(v) && v !== "none";
}

export function firstAllowedPath(user) {
  if (user?.role === "admin") return "/materiale";
  const m = MODULES.find((x) => can(user, x.key));
  return m ? m.path : "/fara-acces";
}
